import { getCurrentOffer, recordFounderClick } from '@/api/next-apis/offers-api';
import { isDocumentAgentPath } from '@/pages/routes-config';
import { Config } from '@/utils/config';
import { useQuery } from '@tanstack/react-query';
import { isNativeApp, OPEN_BOOK_CALL_EVENT } from '@workspace/global-utils';
import { useLocation } from 'react-router-dom';

const OFFER_STALE_MS = 5 * 60 * 1000;

// Preview is included because export opens from there. The API only returns an offer to
// signed-in members with billing access, so recipients on shared links never get one.
export const useExclusiveOffer = () => {
  const { pathname } = useLocation();
  const isOfferPage =
    pathname.startsWith('/project/edit/') ||
    pathname.startsWith('/project/preview/') ||
    isDocumentAgentPath(pathname);

  const { data: offer } = useQuery({
    queryKey: ['exclusive-offer'],
    queryFn: getCurrentOffer,
    enabled: isOfferPage && Config.APP_RUN_TYPE !== 'guest' && !isNativeApp(),
    staleTime: OFFER_STALE_MS,
  });

  const talkToFounder = () => {
    recordFounderClick();
    window.dispatchEvent(new Event(OPEN_BOOK_CALL_EVENT));
  };

  return { offer: isOfferPage ? (offer ?? null) : null, talkToFounder };
};
